import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function ServicesSection() {
  const {
    lang
  } = useLanguage();
  const caminos = [{
    id: 'construye',
    accent: '#A78BCA',
    tag: 'CAMINO 01',
    name: 'Construye',
    nameEn: 'Build',
    tagline: 'Tienes el talento. Nosotros construimos el negocio.',
    taglineEn: 'You have the talent. We build the business.',
    badge: 'Para quien empieza desde cero',
    badgeEn: 'For those starting from scratch',
    checklist: ['Sesión de claridad — qué vendes, a quién y cómo', 'Identidad visual y posicionamiento', 'Web profesional con sistema de cobro', 'Email corporativo + dominio', 'Redes sociales configuradas', 'Brand kit + plantillas en Canva', 'Dashboard para ver tu actividad web', 'LLC en Florida (add-on opcional)'],
    checklistEn: ['Clarity session — what you sell, to whom and how', 'Visual identity and positioning', 'Professional website with payment system', 'Corporate email + domain', 'Social media setup', 'Brand kit + Canva templates', 'Dashboard to view your web activity', 'Florida LLC (optional add-on)'],
    cta: 'Quiero construir mi negocio',
    ctaEn: 'I want to build my business',
    footer: '⏱ Tiempo de entrega: 7–10 días',
    footerEn: '⏱ Delivery time: 7–10 days',
    waText: 'Hola! Me interesa el camino Construye'
  }, {
    id: 'reactiva',
    accent: '#C4A882',
    tag: 'CAMINO 02',
    name: 'Reactiva',
    nameEn: 'Reactivate',
    tagline: 'Tu negocio existe. Hagámoslo funcionar de verdad.',
    taglineEn: "Your business exists. Let's make it really work.",
    badge: 'Para quien ya tiene algo pero está estancado',
    badgeEn: 'For those who have something but are stuck',
    checklist: ['Auditoría digital completa', 'Rediseño o mejora de presencia', 'Mensaje y oferta clarificados', 'Sistema de captación y cobro activado', 'Estrategia de contenido inicial', 'Dashboard actualizado'],
    checklistEn: ['Complete digital audit', 'Redesign or presence improvement', 'Clarified message and offer', 'Capture and payment system activated', 'Initial content strategy', 'Updated dashboard'],
    cta: 'Quiero reactivar lo que tengo',
    ctaEn: 'I want to reactivate what I have',
    footer: '⏱ Tiempo de entrega: 5–14 días',
    footerEn: '⏱ Delivery time: 5–14 days',
    waText: 'Hola! Me interesa el camino Reactiva'
  }, {
    id: 'trasciende',
    accent: '#88AF9C',
    tag: 'CAMINO 03',
    name: 'Trasciende',
    nameEn: 'Transcend',
    tagline: 'Tienes el negocio. Ahora vamos por más.',
    taglineEn: "You have the business. Now let's go for more.",
    badge: 'Para quien quiere crecer con propósito',
    badgeEn: 'For those who want to grow with purpose',
    checklist: ['Estrategia de crecimiento digital', 'Meta Ads + gestión de campañas', '2 sesiones de mentoría al mes', 'Plan de contenido mensual', 'Optimización de funnel y conversión', 'Acceso directo por WhatsApp'],
    checklistEn: ['Digital growth strategy', 'Meta Ads + campaign management', '2 mentoring sessions per month', 'Monthly content plan', 'Funnel and conversion optimization', 'Direct WhatsApp access'],
    cta: 'Quiero crecer con estrategia',
    ctaEn: 'I want to grow with strategy',
    footer: '⏱ Compromiso mínimo: 3 meses',
    footerEn: '⏱ Minimum commitment: 3 months',
    waText: 'Hola! Me interesa el camino Trasciende'
  }];
  return <section id="servicios" className="relative overflow-hidden py-14 lg:py-24 bg-[linear-gradient(135deg,#2E1F47_0%,#5A4579_60%,#3D2F5A_100%)]" data-id="element-396">
      {/* Decorative blurred circles */}
      <div aria-hidden="true" className="pointer-events-none absolute -top-20 -right-20 w-[200px] h-[200px] lg:w-[400px] lg:h-[400px] rounded-full bg-[rgba(167,139,202,0.15)] blur-[80px]" data-id="element-397" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-20 -left-20 w-[150px] h-[150px] lg:w-[300px] lg:h-[300px] rounded-full bg-[rgba(90,69,121,0.2)] blur-[60px]" data-id="element-398" />
      {/* Subtle grain texture overlay */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} data-id="element-399" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8" data-id="element-400">
        {/* ─────────────── HEADER ─────────────── */}
        <div className="text-center mb-12 lg:mb-20" data-id="element-401">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center gap-4 mb-8" data-id="element-402">
            <span className="block w-[1px] h-[40px] bg-white/30" data-id="element-403" />
            <span className="inline-block font-sans text-[10px] font-semibold tracking-[3px] uppercase text-white/60" data-id="element-404">
              {lang === 'es' ? 'NUESTROS SERVICIOS' : 'OUR SERVICES'}
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.1
        }} className="font-display text-[32px] sm:text-[4vw] lg:text-[56px] text-white leading-[1.1] tracking-[-0.5px] mb-6" data-id="element-405">
            {lang === 'es' ? <>
                ¿En qué <em className="italic text-[#A78BCA]" data-id="element-406">etapa</em> estás?
              </> : <>
                What <em className="italic text-[#A78BCA]" data-id="element-407">stage</em> are you
                in?
              </>}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="text-[16px] lg:text-[18px] text-white/65 max-w-[600px] mx-auto font-light leading-[1.8]" data-id="element-408">
            {lang === 'es' ? 'No existe un plan genérico aquí. Empezamos por entender dónde estás — y construimos desde ahí.' : 'There is no generic plan here. We start by understanding where you are — and build from there.'}
          </motion.p>
        </div>

        {/* ─────────────── GLASS CARDS ─────────────── */}
        <div className="flex flex-col lg:grid lg:grid-cols-3 gap-4 lg:gap-8 mb-12 lg:mb-16" data-id="element-409">
          {caminos.map((camino, index) => <motion.div key={camino.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: index * 0.15
        }} className="group relative flex flex-col w-full rounded-[16px] lg:rounded-[20px] overflow-hidden bg-[rgba(255,255,255,0.08)] [backdrop-filter:blur(20px)] [-webkit-backdrop-filter:blur(20px)] border border-[rgba(255,255,255,0.15)] shadow-[0_8px_32px_rgba(0,0,0,0.3),inset_0_1px_0_rgba(255,255,255,0.1)] transition-all duration-[250ms] ease-in-out hover:-translate-y-1.5 hover:border-[rgba(255,255,255,0.3)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.4),inset_0_1px_0_rgba(255,255,255,0.1)]" data-id="element-410">
              {/* Top accent line */}
              <div className="h-[2px] w-full transition-all duration-[250ms] group-hover:shadow-[0_0_12px_2px_currentColor]" style={{
            backgroundColor: camino.accent,
            color: camino.accent
          }} data-id="element-411" />

              <div className="flex flex-col flex-1 p-6 lg:p-8" data-id="element-412">
                {/* Camino tag */}
                <div className="text-[10px] font-sans font-semibold tracking-[3px] uppercase text-white/50 mb-3" data-id="element-413">
                  {camino.tag}
                </div>
                {/* Title */}
                <h3 className="font-display font-bold text-[24px] lg:text-[28px] text-white leading-tight mb-2" data-id="element-414">
                  {lang === 'es' ? camino.name : camino.nameEn}
                </h3>
                {/* Tagline */}
                <p className="italic text-[14px] text-white/75 leading-[1.6] mb-5" data-id="element-415">
                  {lang === 'es' ? camino.tagline : camino.taglineEn}
                </p>
                {/* Target badge */}
                <div className="inline-flex self-start items-center rounded-full text-[12px] text-white px-[14px] py-[6px] bg-[rgba(255,255,255,0.12)] border border-[rgba(255,255,255,0.2)]" data-id="element-416">
                  {lang === 'es' ? camino.badge : camino.badgeEn}
                </div>

                {/* Divider */}
                <div className="h-[1px] w-full bg-[rgba(255,255,255,0.1)] my-6" data-id="element-417" />

                {/* Checklist */}
                <ul className="flex-1 space-y-3 mb-8" data-id="element-418">
                  {(lang === 'es' ? camino.checklist : camino.checklistEn).map((item, i) => <li key={i} className="flex items-start gap-3 text-[13px] lg:text-[14px] text-white/85 font-light leading-[1.5]" data-id="element-419">
                        <Check className="w-[18px] h-[18px] text-[#A78BCA] shrink-0 mt-0.5" strokeWidth={1.75} data-id="element-420" />
                        <span data-id="element-421">{item}</span>
                      </li>)}
                </ul>

                {/* CTA */}
                <a href={`https://wa.me/13054781618?text=${encodeURIComponent(camino.waText)}`} target="_blank" rel="noopener noreferrer" className="block w-full text-center rounded-[100px] font-sans font-semibold text-[13px] text-white px-6 py-3 mb-5 bg-[rgba(255,255,255,0.15)] border border-[rgba(255,255,255,0.3)] transition-all duration-200 ease-in-out hover:bg-[rgba(255,255,255,0.25)] hover:border-[rgba(255,255,255,0.5)]" data-id="element-422">
                  {lang === 'es' ? camino.cta : camino.ctaEn}
                </a>

                <div className="text-[13px] text-white/50 text-center font-light" data-id="element-423">
                  {lang === 'es' ? camino.footer : camino.footerEn}
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* ─────────────── CLOSING NOTE ─────────────── */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.4
      }} className="text-center text-white/65 text-[16px] font-light italic" data-id="element-424">
          {lang === 'es' ? <>
              ¿No sabes cuál es tu camino?{' '}
              <a href="https://calendly.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="text-[#A78BCA] font-medium underline underline-offset-4 decoration-[#A78BCA] hover:text-white transition-colors" data-id="element-425">
                La Sesión Diagnóstico existe exactamente para eso.
              </a>
            </> : <>
              Don't know which path is yours?{' '}
              <a href="https://calendly.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="text-[#A78BCA] font-medium underline underline-offset-4 decoration-[#A78BCA] hover:text-white transition-colors" data-id="element-426">
                The Diagnostic Session exists exactly for that.
              </a>
            </>}
        </motion.div>
      </div>
    </section>;
}